import { setTokens } from './authStorage';

function apiBase(): string {
  const envUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;
  if (envUrl && envUrl.trim()) return envUrl.trim().replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin && !/^https?:\/\/localhost(:\d+)?$/i.test(window.location.origin)) {
    return `${window.location.origin}/api`;
  }
  return 'http://localhost:8000/api';
}

/** Échange le code d'entrée, puis retire le fragment avant le chargement de l'app. */
export async function consumeSessionHandoff(): Promise<void> {
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash.startsWith('entry=')) return;
  const code = decodeURIComponent(hash.slice('entry='.length));
  const clean = `${window.location.pathname}${window.location.search}`;
  window.history.replaceState(null, '', clean);
  if (!code) return;
  try {
    const response = await fetch(`${apiBase()}/auth/auth/redeem-agence-entry/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    });
    if (!response.ok) return;
    const data = await response.json() as { tokens?: { access?: string; refresh?: string } };
    if (!data.tokens?.access) return;
    setTokens(data.tokens.access, data.tokens.refresh || null, true);
  } catch {
    /* code illisible ou réseau : l'adresse est déjà nettoyée */
  }
}
